var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiClient } from "@/api/ApiClient";
import "./CategoryDropdown.css";
import { useWindowResize } from "@/hooks/useWindowResize";
import { useClickAndEscape } from "@/hooks/useClickAndEscape";
const CategoryDropdown = ({ onItemSelected }) => {
    const navigate = useNavigate();
    const [categories, setCategories] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [activeCategory, setActiveCategory] = useState(null);
    const dropdownRef = React.useRef(null);
    const isMobile = useWindowResize(600);
    const closeMenu = useCallback(() => {
        setIsOpen(false);
        setActiveCategory(null);
    }, []);
    useClickAndEscape(dropdownRef, isOpen, closeMenu);
    useEffect(() => {
        const fetchCategories = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const response = yield apiClient.getAllCategories({ limit: 500 });
                const allCategories = response.results;
                const categoryTree = buildCategoryTree(allCategories);
                setCategories(categoryTree);
            }
            catch (error) {
                console.error("Error fetching categories:", error);
            }
        });
        fetchCategories();
    }, []);
    const buildCategoryTree = (allCategories) => {
        const categoryMap = new Map();
        allCategories.forEach((category) => {
            categoryMap.set(category.id, Object.assign(Object.assign({}, category), { children: [] }));
        });
        const rootCategories = [];
        categoryMap.forEach((category) => {
            var _a;
            if (category.parent) {
                const parent = categoryMap.get(category.parent.id);
                if (parent) {
                    (_a = parent.children) === null || _a === void 0 ? void 0 : _a.push(category);
                }
            }
            else {
                rootCategories.push(category);
            }
        });
        const sortCategories = (categories) => {
            return [...categories]
                .sort((a, b) => {
                return (a.orderHint || "").localeCompare(b.orderHint || "");
            })
                .map((category) => {
                if (category.children.length > 0) {
                    return Object.assign(Object.assign({}, category), { children: sortCategories(category.children) });
                }
                return category;
            });
        };
        return sortCategories(rootCategories);
    };
    const getCategoryName = (category) => {
        var _a;
        return ((_a = category.name) === null || _a === void 0 ? void 0 : _a["en-US"]) || category.key || "Unnamed Category";
    };
    const handleCategoryClick = (category) => {
        var _a, _b;
        if (isMobile) {
            if ((_a = category.children) === null || _a === void 0 ? void 0 : _a.length) {
                setActiveCategory(category.id);
            }
            else {
                navigate(`/category/${((_b = category.slug) === null || _b === void 0 ? void 0 : _b["en-US"]) || category.id}`);
                closeMenu();
                onItemSelected === null || onItemSelected === void 0 ? void 0 : onItemSelected();
            }
        }
        else {
            setActiveCategory(category.id);
            closeMenu();
            onItemSelected === null || onItemSelected === void 0 ? void 0 : onItemSelected();
        }
    };
    const handleBackClick = () => {
        setActiveCategory(null);
    };
    return (_jsxs("div", { className: "category-dropdown", ref: dropdownRef, children: [_jsx("button", { className: "dropdown-toggle", onClick: () => {
                    navigate("/category");
                    setIsOpen(!isOpen);
                    setActiveCategory(null);
                }, onMouseEnter: () => !isMobile && setIsOpen(true), children: "Categories" }), isOpen && (_jsxs("div", { className: `mega-menu ${isMobile ? "mobile-view" : ""}`, children: [isMobile && activeCategory && (_jsx("button", { className: "back-button", onClick: handleBackClick, children: "\u2190 Back to Categories" })), (!isMobile || !activeCategory) && (_jsx("div", { className: "main-categories", children: categories.map((category) => {
                            var _a;
                            return (_jsxs("div", { className: `main-category ${activeCategory === category.id ? "active" : ""}`, onClick: () => handleCategoryClick(category), onMouseEnter: () => !isMobile && setActiveCategory(category.id), children: [_jsx(Link, { to: `/category/${((_a = category.slug) === null || _a === void 0 ? void 0 : _a["en-US"]) || category.id}`, className: "main-category-link", children: getCategoryName(category) }), category.children.length > 0 && (_jsx("span", { className: "arrow", children: "\u203A" }))] }, category.id));
                        }) })), activeCategory && (_jsx("div", { className: "subcategories-panel", children: categories
                            .filter((category) => category.id === activeCategory)
                            .map((category) => {
                            var _a;
                            return (_jsx("div", { className: "subcategories-columns", children: (_a = category.children) === null || _a === void 0 ? void 0 : _a.map((child) => {
                                    var _a, _b;
                                    return (_jsxs("div", { className: "subcategory-group", children: [_jsx("h4", { className: "subcategory-title", children: _jsx(Link, { to: `/category/${((_a = child.slug) === null || _a === void 0 ? void 0 : _a["en-US"]) || child.id}`, className: "subcategory-link", onClick: () => {
                                                        closeMenu();
                                                        onItemSelected === null || onItemSelected === void 0 ? void 0 : onItemSelected();
                                                    }, children: getCategoryName(child) }) }), (_b = child.children) === null || _b === void 0 ? void 0 : _b.map((subChild) => {
                                                var _a;
                                                return (_jsx(Link, { to: `/category/${((_a = subChild.slug) === null || _a === void 0 ? void 0 : _a["en-US"]) || subChild.id}`, className: "subcategory-item", onClick: () => {
                                                        closeMenu();
                                                        onItemSelected === null || onItemSelected === void 0 ? void 0 : onItemSelected();
                                                    }, children: getCategoryName(subChild) }, subChild.id));
                                            })] }, child.id));
                                }) }, category.id));
                        }) }))] }))] }));
};
export default CategoryDropdown;
